import InternalShipmentTools from "./InternalShipmentTools";
import {
  Board,
  boardHasBeenPaidFor,
  ProductionStatus,
  Shipment,
} from "../../../../reducers/uploadedBoard";
import EditableShipmentRow from "./EditableShipment";
import CustomerShipmentSummary from "./CustomerShipmentSummary";
import { useAppSelector } from "../../../../utils/hooks/store";
import { useBoardFromContext } from "../../../../utils/hooks/commonly-stored/uploaded-board/board";
import { ShipmentsColumnContainer } from "./ShipmentsStyles";

export default function ShipmentTools({
  shipment,
  allowRemove,
}: {
  shipment: Shipment;
  allowRemove?: boolean;
}) {
  const board = useBoardFromContext().board as Board;
  const isAdminOrEngineer = useAppSelector(
    (state) => state.auth.isAdminOrEngineer,
  );

  const boardIsOrdered = boardHasBeenPaidFor(board);

  if (!boardIsOrdered) {
    return (
      <EditableShipmentRow shipment={shipment} allowRemove={allowRemove} />
    );
  }

  if (shipment.production_status == ProductionStatus.CANCELED) {
    return <CustomerShipmentSummary shipment={shipment} />;
  }

  return (
    <ShipmentsColumnContainer>
      {isAdminOrEngineer ? (
        <EditableShipmentRow shipment={shipment} allowRemove={allowRemove} />
      ) : (
        <CustomerShipmentSummary shipment={shipment} />
      )}
      {isAdminOrEngineer && <InternalShipmentTools shipment={shipment} />}
    </ShipmentsColumnContainer>
  );
}
